<template>
    <div>
        <img v-if="fileUrl" class="rounded mb-3" style="width: 90px" :src="fileUrl" />
        <input class="w-100" ref="file" type="file" id="file" accept="image/*" @change="compressFile">
    </div>
</template>

<script>
import Compressor from 'compressorjs';
export default {
    data() {
        return {
            fileUrl: null
        }
    },
    methods: {
        compressFile(e) {
            const file = e.target.files[0];

            if (!file) {
                return;
            }

            let resultCompression = (imgResult) => {
                this.fileUrl = URL.createObjectURL(imgResult)
                this.$emit('input', imgResult)
            }

            new Compressor(file, {
                quality: 0.5,
                convertSize: 3,
                convertTypes: ['image/png', 'image/webp'],

                success(result) {
                    resultCompression(result)
                },
                error(err) {
                    console.warn('Error image compression:');
                    console.log(err.message);
                },
            });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/SavImageInput.vue